module.exports = __webpack_public_path__ + "img/share.4797307b.jpg";